import "./orders.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faTruck, faClock, faMoneyBillWave, faUndo, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function Orders() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Orders - Track Your Purchases</title>
        <meta
          name="description"
          content="View and track your orders at SHOP.CO. Get updates on your purchases, delivery status, and order history all in one place."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/FAQ/orders/"
        />
      </Helmet>
      <div className="orders-container">
        <h1>Your Orders</h1>
        <p className="orders-subtitle">
          Learn how to track, manage, or request support for your orders.
        </p>

        <div className="orders-sections">

          <div className="orders-card">
            <FontAwesomeIcon icon={faBox} className="orders-icon" />
            <h3>Order Status</h3>
            <p>View the current status of your orders – whether they are being processed, shipped, or delivered.</p>
          </div>

          <div className="orders-card">
            <FontAwesomeIcon icon={faTruck} className="orders-icon" />
            <h3>Track Your Order</h3>
            <p>Use the tracking number provided in your order details to follow your package in real-time.</p>
          </div>

          <div className="orders-card">
            <FontAwesomeIcon icon={faClock} className="orders-icon" />
            <h3>Order History</h3>
            <p>Access your full order history anytime from your account dashboard.</p>
          </div>

          <div className="orders-card">
            <FontAwesomeIcon icon={faMoneyBillWave} className="orders-icon" />
            <h3>Payment Information</h3>
            <p>Check the payment method used, transaction ID, and payment status for every order.</p>
          </div>

          <div className="orders-card">
            <FontAwesomeIcon icon={faUndo} className="orders-icon" />
            <h3>Returns & Refunds</h3>
            <p>If you’re not satisfied with a product, you can request a return or refund from the order details page.</p>
          </div>

          <div className="orders-card">
            <FontAwesomeIcon icon={faQuestionCircle} className="orders-icon" />
            <h3>Need Help?</h3>
            <p>Contact our support team from your order details page if you face any issues with a recent purchase.</p>
          </div>

        </div>
      </div>
    </>
  );
}
